import cn from './cn.js';

/**
 * Field wraps a form control with a label, optional hint, counter and error.
 */
export default function Field({
  label,
  htmlFor,
  hint,
  error,
  required = false,
  optional = false,
  trailing,
  className,
  children,
}) {
  return (
    <div className={cn('space-y-1.5', className)}>
      {(label || trailing) && (
        <div className="flex items-center justify-between gap-3">
          {label && (
            <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700">
              {label}
              {required && <span className="ml-0.5 text-red-500" aria-hidden="true">*</span>}
              {optional && <span className="ml-1.5 text-xs font-normal text-gray-400">Optional</span>}
            </label>
          )}
          {trailing && <span className="text-xs text-gray-400">{trailing}</span>}
        </div>
      )}
      {children}
      {error ? (
        <p className="text-xs text-red-600" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-xs text-gray-500">{hint}</p>
      ) : null}
    </div>
  );
}

export function Label({ htmlFor, className, children, ...props }) {
  return (
    <label htmlFor={htmlFor} className={cn('block text-sm font-medium text-gray-700', className)} {...props}>
      {children}
    </label>
  );
}
